(function () {
  const cfg = window.SCHOOL_SEARCH_CONFIG || {};
  const proxyUrl = cfg.proxyUrl || "/apps/school-products";
  const bannerSections = cfg.bannerSections || ["main-collection-banner"];
  // const allowed = Array.isArray(cfg.allowedHandles) ? cfg.allowedHandles : null;

  const elSchool = document.getElementById("SchoolSelect");
  const elGrade = document.getElementById("GradeSelect");
  const elHint = document.getElementById("GradeHint");
  const elStatus = document.getElementById("SchoolSearchStatus");
  const elBanner = document.getElementById("SchoolSearchBannerContent");
const elProducts = document.getElementById("SchoolSearchProductsContent");

const elBannerSkeleton = document.getElementById("SchoolSearchBannerSkeleton");
const elProductsSkeleton = document.getElementById("SchoolSearchProductsSkeleton");
const elBannerWrap = document.getElementById("SchoolSearchBannerWrap");
const elProductsWrap = document.getElementById("SchoolSearchProductsWrap");
  const elCollectionTitle = document.getElementById("SchoolSearchCollectionTitle");
const SCHOOL_DISPLAY_NAMES = {
  "ndb": "Notre Dame Belmont"
};

const SCHOOL_STORAGE_KEY = "school_search_selected_school";

    function getSelectedSchoolHandle() {
  return String(elSchool?.value || "").trim();
}

function addSchoolQueryToUrl(rawUrl) {
  const schoolHandle = getSelectedSchoolHandle();

  if (!schoolHandle || !rawUrl) return rawUrl;

  try {
    const url = new URL(rawUrl, window.location.origin);
    url.searchParams.set("school", schoolHandle);
    return url.pathname + url.search + url.hash;
  } catch (e) {
    const separator = rawUrl.includes("?") ? "&" : "?";
    return `${rawUrl}${separator}school=${encodeURIComponent(schoolHandle)}`;
  }
}

function addSchoolQueryToProductLinks(rootEl) {
  const schoolHandle = getSelectedSchoolHandle();
  if (!schoolHandle || !rootEl) return;

  rootEl.querySelectorAll('a[href*="/products/"]').forEach((link) => {
    const href = link.getAttribute("href") || "";
    link.setAttribute("href", addSchoolQueryToUrl(href));
  });
}


  if (!elSchool || !elGrade || !elBanner || !elProducts) return;

  // Proxy-backed store
  let PROXY_HANDLES = [];
  let PROXY_GRADE_BY_HANDLE = {};
  let PROXY_SORT_ORDER = "";

  // Cache products so we don't refetch on grade filter changes
  const PRODUCT_CACHE = new Map(); // handle -> product JSON

  function setStatus(msg) {
  if (!elStatus) return;
  elStatus.innerHTML = msg ? `<span class="school-search__status-text">${msg}</span>` : "";
}

function setProductsLoading(isLoading) {
  if (!elProducts) return;

  if (isLoading) {
    elProducts.classList.add("school-search__products--loading");
    elProducts.setAttribute("aria-busy", "true");
  } else {
    elProducts.classList.remove("school-search__products--loading");
    elProducts.removeAttribute("aria-busy");
  }
}

function showLoader(type = "products") {
  if (!elStatus) return;

  const label =
    type === "school" ? "Loading school..." : "Loading products...";

  elStatus.innerHTML = `
    <div class="school-search__loader" aria-live="polite" aria-label="${label}">
      <span class="school-search__spinner"></span>
    </div>
  `;
}

function clearStatus() {
  if (!elStatus) return;
  elStatus.innerHTML = "";
}

  function showBannerSkeleton() {
  if (elBannerSkeleton) elBannerSkeleton.style.display = "block";
  if (elBannerSkeleton) elBannerSkeleton.style.visibility = "visible";
  if (elBanner) elBanner.style.display = "none";
}

function hideBannerSkeleton() {
  if (elBannerSkeleton) elBannerSkeleton.style.display = "none";
  if (elBanner) elBanner.style.display = "block";
}

function showProductsSkeleton() {
  if (elProductsSkeleton) elProductsSkeleton.style.display = "block";
  if (elProductsSkeleton) elProductsSkeleton.style.visibility = "visible";
  if (elProducts) elProducts.style.display = "none";
}

function hideProductsSkeleton() {
  if (elProductsSkeleton) elProductsSkeleton.style.display = "none";
  if (elProducts) elProducts.style.display = "block";
}

function showAllSkeletons() {
  showBannerSkeleton();
  showProductsSkeleton();
}

function hideAllSkeletons() {
  hideBannerSkeleton();
  hideProductsSkeleton();
}

  function enableGrade(enabled) {
    elGrade.disabled = !enabled;
    if (elHint) elHint.textContent = enabled ? "Optional: select a grade to filter" : "Select a school to load products";
  }

  // function isAllowed(handle) {
  //   if (!handle) return false;
  //   if (!allowed) return true;
  //   return allowed.includes(handle);
  // }

  async function fetchSchoolOptions() {
  const url = new URL(proxyUrl, window.location.origin);
  url.searchParams.set("mode", "schools");

  const res = await fetch(url.toString(), { credentials: "same-origin" });
  if (!res.ok) throw new Error("School list fetch failed");

  return await res.json();
}

  function fillSchoolOptions(schools) {
  elSchool.innerHTML = `<option value="">Select School</option>`;

  (schools || []).forEach((school) => {
    const handle = String(school.collection_handle || "").trim();
    const title = String(school.collection_title || "").trim();

    if (!handle || !title) return;

    const opt = document.createElement("option");
    opt.value = handle;
    opt.textContent = title;
    elSchool.appendChild(opt);
  });
}

  async function initSchoolDropdown() {
  try {
    showLoader("school");

    const data = await fetchSchoolOptions();
    const schools = Array.isArray(data.schools) ? data.schools : [];

    fillSchoolOptions(schools);

    const savedSchool = localStorage.getItem(SCHOOL_STORAGE_KEY);

    if (savedSchool) {
      const exists = Array.from(elSchool.options).some(
        (option) => option.value === savedSchool
      );

      if (exists) {
        elSchool.value = savedSchool;
        await onSchoolChange();
      }
    }

    clearStatus();
  } catch (e) {
    setStatus("Could not load schools.");
  }
}

  async function fetchProxyData(handle, grade = "") {
  const url = new URL(proxyUrl, window.location.origin);
  url.searchParams.set("collection_handle", handle);

  if (String(grade || "").trim()) {
    url.searchParams.set("grade", String(grade).trim());
  }

  const res = await fetch(url.toString(), { credentials: "same-origin" });
  if (!res.ok) throw new Error("Proxy error");
  return await res.json();
}

  function fillGrades(grades) {
    const sorted = (grades || [])
      .map((g) => String(g).trim())
      .filter(Boolean)
      .sort((a, b) => Number(a) - Number(b));

    elGrade.innerHTML = `<option value="">Select Grade</option>`;
    sorted.forEach((g) => {
      const opt = document.createElement("option");
      opt.value = g;
      opt.textContent = g;
      elGrade.appendChild(opt);
    });
  }

  function clearOutput() {
  if (elBanner) elBanner.innerHTML = "";
  if (elProducts) elProducts.innerHTML = "";

  showAllSkeletons();

  if (elCollectionTitle) {
    elCollectionTitle.textContent = "";
    elCollectionTitle.style.display = "none";
  }

  PROXY_HANDLES = [];
  PROXY_GRADE_BY_HANDLE = {};
  PROXY_SORT_ORDER = "";
  PRODUCT_CACHE.clear();
}

  // ---------- Title helpers (School + optional Grade) ----------

  function ordinal(n) {
    const num = parseInt(n, 10);
    if (Number.isNaN(num)) return String(n);

    const mod10 = num % 10;
    const mod100 = num % 100;

    if (mod10 === 1 && mod100 !== 11) return `${num}st`;
    if (mod10 === 2 && mod100 !== 12) return `${num}nd`;
    if (mod10 === 3 && mod100 !== 13) return `${num}rd`;
    return `${num}th`;
  }

  function updateCollectionTitle() {
  if (!elCollectionTitle) return;

  const handle = String(elSchool?.value || "").trim();

  if (!handle) {
    elCollectionTitle.textContent = "";
    elCollectionTitle.style.display = "none";
    return;
  }

  // Use custom name if exists, otherwise fallback to dropdown text
  const fallbackName =
    elSchool?.options?.[elSchool.selectedIndex]?.textContent?.trim() || "";

  const schoolName =
    SCHOOL_DISPLAY_NAMES[handle] || fallbackName;

  const gradeVal = String(elGrade?.value || "").trim();

  const title = gradeVal
    ? `${schoolName.toUpperCase()}  ${ordinal(gradeVal).toUpperCase()} GRADE UNIFORMS`
    : `${schoolName.toUpperCase()}  `;

  elCollectionTitle.textContent = title;
  elCollectionTitle.style.display = "block";
}

  // ---------- Banner (from Shopify) ----------

  async function renderBanner(handle) {
  try {
    showBannerSkeleton();

    const url = new URL(`/collections/${handle}`, window.location.origin);
    url.searchParams.set("sections", bannerSections.join(","));
    const res = await fetch(url.toString(), { credentials: "same-origin" });
    if (!res.ok) throw new Error("Banner load failed");

    const data = await res.json();

    let html = "";
    bannerSections.forEach((k) => {
      if (data[k]) html += data[k];
    });

    elBanner.innerHTML = html;
  } catch (e) {
    elBanner.innerHTML = "";
  } finally {
    hideBannerSkeleton();
  }
}

  // ---------- Product JSON helpers ----------

  async function fetchProductByHandle(handle) {
    if (PRODUCT_CACHE.has(handle)) return PRODUCT_CACHE.get(handle);

    const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) return null;
    const json = await res.json();
    PRODUCT_CACHE.set(handle, json);
    return json;
  }

  async function fetchCollectionProductsJson(collectionHandle, sortBy) {
  const url = new URL(`/collections/${collectionHandle}/products.json`, window.location.origin);
  url.searchParams.set("limit", "250");

  if (sortBy) {
    url.searchParams.set("sort_by", sortBy);
  }

  const res = await fetch(url.toString(), { credentials: "same-origin" });
  if (!res.ok) throw new Error("Collection products JSON failed");

  return await res.json();
}

  function shopifySizedImage(url, width) {
    if (!url) return "";
    const [base, query] = url.split("?");
    const dot = base.lastIndexOf(".");
    if (dot === -1) return url;

    const path = base.slice(0, dot);
    const ext = base.slice(dot);
    const sized = `${path}_${width}x${ext}`;
    return query ? `${sized}?${query}` : sized;
  }

  function shopifySrcset(url, widths) {
    return widths.map((w) => `${shopifySizedImage(url, w)} ${w}w`).join(", ");
  }

  function moneyFromCents(cents) {
    if (typeof cents !== "number") return "";
    return `$${(cents / 100).toFixed(2)}`;
  }

  function getProductPriceText(product) {
  if (!product) return "";

  // Case 1: /products/{handle}.js
  if (typeof product.price === "number") {
    return moneyFromCents(product.price);
  }

  // Case 2: /collections/{handle}/products.json
  if (Array.isArray(product.variants) && product.variants.length) {
    const raw = product.variants[0]?.price;

    if (typeof raw === "number") {
      return `$${raw.toFixed(2)}`;
    }

    if (typeof raw === "string" && raw.trim() !== "") {
      return `$${raw}`;
    }
  }

  return "";
}

  function firstProductImage(product) {
  if (!product || !Array.isArray(product.images) || !product.images.length) return "";

  const first = product.images[0];

  if (typeof first === "string") return first;
  if (first && typeof first.src === "string") return first.src;

  return "";
}

  function handleMatchesGrade(handle, grade) {
    const g = String(grade || "").trim();
    if (!g) return true; // if no grade selected, show ALL products

    const raw = String(PROXY_GRADE_BY_HANDLE?.[handle] || "").trim();
    if (!raw) return false; // blank mapping => hide in filtered views

    const grades = raw.split(",").map((x) => x.trim()).filter(Boolean);
    return grades.includes(g);
  }

  function sortProductEntries(entries, sortOrder) {
  const arr = [...entries].filter((entry) => entry && entry.product);

  switch (sortOrder) {
    case "MANUAL":
      return arr; // keep proxy order exactly as received

    case "TITLE_ASC":
      return arr.sort((a, b) =>
        (a.product.title || "").localeCompare(b.product.title || "")
      );

    case "TITLE_DESC":
      return arr.sort((a, b) =>
        (b.product.title || "").localeCompare(a.product.title || "")
      );

    case "PRICE_ASC":
      return arr.sort((a, b) =>
        Number(a.product.price || 0) - Number(b.product.price || 0)
      );

    case "PRICE_DESC":
      return arr.sort((a, b) =>
        Number(b.product.price || 0) - Number(a.product.price || 0)
      );

    case "CREATED_ASC":
      return arr.sort((a, b) =>
        new Date(a.product.published_at || 0) - new Date(b.product.published_at || 0)
      );

    case "CREATED_DESC":
      return arr.sort((a, b) =>
        new Date(b.product.published_at || 0) - new Date(a.product.published_at || 0)
      );

    default:
      return arr;
  }
}

  function renderProductCardsFromProducts(products) {
  if (!products || !products.length) {
    elProducts.innerHTML = `<p style="text-align:center;opacity:.7;margin:24px 0;">No products found.</p>`;
  hideProductsSkeleton();
  clearStatus();
  return;
  }

  const cards = products
    .map((p) => {
      if (!p) return "";

      const handle = p.handle || "";
      const baseUrl = p.url || `/products/${handle}`;
      const url = addSchoolQueryToUrl(baseUrl);
      const title = p.title || "";
      const img = firstProductImage(p);
      const priceText = getProductPriceText(p);

      return `
        <a class="school-search-card" href="${url}">
          <div class="school-search-card__img">
            ${
              img
                ? `
              <img
                loading="lazy"
                decoding="async"
                src="${shopifySizedImage(img, 360)}"
                srcset="${shopifySrcset(img, [180, 240, 360, 540, 720])}"
                sizes="(max-width: 520px) 90vw, (max-width: 990px) 45vw, 22vw"
                alt="${title.replace(/"/g, "&quot;")}"
              >
            `
                : ""
            }
          </div>
          <div class="school-search-card__title">${title}</div>
          <div class="school-search-card__price">${priceText}</div>
        </a>
      `;
    })
    .join("");

  elProducts.innerHTML = `<div class="school-search-grid">${cards}</div>`;
hideProductsSkeleton();
clearStatus();
}

    async function renderBestSellingProductsByHandles(handles) {
  if (!handles || !handles.length) {
    elProducts.innerHTML = `<p style="text-align:center;opacity:.7;margin:24px 0;">No products found.</p>`;
    hideProductsSkeleton();
    clearStatus();
    return;
  }

  const collectionHandle = String(elSchool?.value || "").trim();
  if (!collectionHandle) {
    elProducts.innerHTML = `<p style="text-align:center;opacity:.7;margin:24px 0;">No products found.</p>`;
    hideProductsSkeleton();
    clearStatus();
    return;
  }

  // setStatus("Loading products...");

  try {
    const data = await fetchCollectionProductsJson(collectionHandle, "best-selling");
    // console.log("BEST_SELLING collection JSON:", data);

    const shopifyProducts = Array.isArray(data.products) ? data.products : [];
    // console.log("Shopify collection products count:", shopifyProducts.length);
    // console.log("Shopify collection handles:", shopifyProducts.map(p => p.handle));
    // console.log("Proxy handles:", handles);

    const allowedHandles = new Set(handles.map((h) => String(h).trim()));

    const orderedProducts = shopifyProducts.filter((p) =>
      allowedHandles.has(String(p.handle || "").trim())
    );

    // console.log("Ordered products after proxy filter:", orderedProducts.length);
    // console.log("Ordered products:", orderedProducts.map(p => p.handle));

    if (!orderedProducts.length) {
      elProducts.innerHTML = `<p style="text-align:center;opacity:.7;margin:24px 0;">No products found.</p>`;
      hideProductsSkeleton();
      clearStatus();
      return;
    }

    renderProductCardsFromProducts(orderedProducts);
  } catch (e) {
    console.error("BEST_SELLING load failed:", e);
    elProducts.innerHTML = `<p style="text-align:center;opacity:.7;margin:24px 0;">Could not load products.</p>`;
    hideProductsSkeleton();
    clearStatus();
  }
}


    async function renderProductsByHandles(handles) {
  if (!handles || !handles.length) {
    elProducts.innerHTML = `<p style="text-align:center;opacity:.7;margin:24px 0;">No products found.</p>`;
    hideProductsSkeleton();
    clearStatus();
    return;
  }

  // BEST_SELLING case (keep as is)
  if (String(PROXY_SORT_ORDER || "").toUpperCase() === "BEST_SELLING") {
    await renderBestSellingProductsByHandles(handles);
    return;
  }

  // setStatus("Loading products...");

  try {
    // ✅ Step 1: fetch Shopify-rendered cards
    const responses = await Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}?view=card`, {
          credentials: "same-origin",
        })
          .then((res) => {
            if (!res.ok) return "";
            return res.text();
          })
          .catch(() => "")
      )
    );

    const cardsHTML = responses.filter(Boolean).join("");

    if (!cardsHTML) {
      elProducts.innerHTML = `<p style="text-align:center;opacity:.7;margin:24px 0;">No products found.</p>`;
      clearStatus();
      return;
    }

    // ✅ Step 2: inject into Shopify-compatible grid
    elProducts.innerHTML = `
  <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop">
    ${cardsHTML}
  </ul>
`;
addSchoolQueryToProductLinks(elProducts);

hideProductsSkeleton();

setTimeout(() => {
  try {
    document.dispatchEvent(new Event("shopify:section:load"));
    document.dispatchEvent(new Event("DOMContentLoaded"));
    window.dispatchEvent(new Event("load"));
  } catch (e) {
    console.log("Re-init trigger failed", e);
  }
}, 300);

clearStatus();
  } catch (e) {
    console.error("Render failed:", e);
    elProducts.innerHTML = `<p style="text-align:center;opacity:.7;margin:24px 0;">Could not load products.</p>`;
    clearStatus();
  }
}

  async function renderAllProductsForSchool() {
    await renderProductsByHandles(PROXY_HANDLES);
  }

  // async function renderFilteredProductsForGrade(grade) {
  //   const filtered = (PROXY_HANDLES || []).filter((h) => handleMatchesGrade(h, grade));
  //   await renderProductsByHandles(filtered);
  // }

  // ---------- Events ----------

  
  async function onSchoolChange() {
  const handle = (elSchool.value || "").trim();

  if (handle) {
    localStorage.setItem(SCHOOL_STORAGE_KEY, handle);
  } else {
    localStorage.removeItem(SCHOOL_STORAGE_KEY);
  }

  elGrade.value = "";

  if (!handle) {
    if (elBanner) {
      elBanner.innerHTML = "";
      elBanner.style.display = "block";
    }

    if (elProducts) {
      elProducts.innerHTML = "";
      elProducts.style.display = "block";
    }

    if (elBannerSkeleton) elBannerSkeleton.style.display = "none";
    if (elProductsSkeleton) elProductsSkeleton.style.display = "none";

    enableGrade(false);
    elGrade.style.display = "none";
    fillGrades([]);
    clearStatus();
    updateCollectionTitle();

    document.querySelector(".school-search__controls").classList.remove("show-grade");
    return;
  }

  clearOutput();
  showAllSkeletons();

  // Enable and show the grade dropdown when a school is selected
  elGrade.style.display = "block";
  enableGrade(true);

  // Change layout: Display both dropdowns side by side
  document.querySelector(".school-search__controls").classList.add("show-grade");
  clearStatus();

  try {
    const data = await fetchProxyData(handle, "");

    PROXY_HANDLES = Array.isArray(data.handles) ? data.handles : [];
    PROXY_GRADE_BY_HANDLE =
      data.gradeByHandle && typeof data.gradeByHandle === "object"
        ? data.gradeByHandle
        : {};
    PROXY_SORT_ORDER = String(data.sort_order || "").trim();

    const grades = Array.isArray(data.available_grades) ? data.available_grades : [];
    fillGrades(grades);

    try {
      await renderBanner(handle);
    } catch (e) {
      // no-op
    }

    updateCollectionTitle();
    await renderAllProductsForSchool();
  } catch (e) {
    enableGrade(false);
    fillGrades([]);
    if (elBannerSkeleton) elBannerSkeleton.style.display = "none";
    if (elProductsSkeleton) elProductsSkeleton.style.display = "none";
    setStatus("Could not load school data.");
    updateCollectionTitle();
  }
}
//   // Enable and show the grade dropdown when a school is selected
//   elGrade.style.display = "block";  // Show the grade dropdown
//   enableGrade(true);

//   // Change layout: Display both dropdowns side by side
//   document.querySelector('.school-search__controls').classList.add('show-grade');
//   clearStatus();
// showAllSkeletons();

//   try {
//     const data = await fetchProxyData(handle, "");

//     PROXY_HANDLES = Array.isArray(data.handles) ? data.handles : [];
//     PROXY_GRADE_BY_HANDLE = data.gradeByHandle && typeof data.gradeByHandle === "object" ? data.gradeByHandle : {};
//     PROXY_SORT_ORDER = String(data.sort_order || "").trim();

//     const grades = Array.isArray(data.available_grades) ? data.available_grades : [];
//     fillGrades(grades);

//     // Banner
//     try {
//       await renderBanner(handle);
//     } catch (e) {
//       // no-op
//     }

//     // ✅ Title should be based on selected school (grade empty at this point)
//     updateCollectionTitle();

//     // ✅ All products
//     await renderAllProductsForSchool();
//   } catch (e) {
//     enableGrade(false);
//     fillGrades([]);
//     setStatus("Could not load school data.");
//     updateCollectionTitle();
//   }
// }

  async function onGradeChange() {
  const handle = (elSchool.value || "").trim();
  const grade = (elGrade.value || "").trim();

  updateCollectionTitle();

  if (!handle) return;

  // Show only product skeleton on grade change
  if (elProducts) elProducts.innerHTML = "";
  showProductsSkeleton();
  clearStatus();

  try {
    const data = await fetchProxyData(handle, grade);

    PROXY_HANDLES = Array.isArray(data.handles) ? data.handles : [];
    PROXY_GRADE_BY_HANDLE =
      data.gradeByHandle && typeof data.gradeByHandle === "object"
        ? data.gradeByHandle
        : {};
    PROXY_SORT_ORDER = String(data.sort_order || "").trim();

    await renderProductsByHandles(PROXY_HANDLES);
  } catch (e) {
    hideProductsSkeleton();
    setStatus("Could not load products.");
  }
}

  elSchool.addEventListener("change", onSchoolChange);
  elGrade.addEventListener("change", onGradeChange);

  enableGrade(false);
  initSchoolDropdown();
})();